export default __webpack_public_path__ + "static/media/edit.d9e6d4f5.svg";